module.exports = __webpack_public_path__ + "static/assets/d3a2ffef1469710b0ae83449c8e130d4.png";